export const RADIUS = 6378137;
export const SUBRADIUS = 1 / RADIUS;
export const ECCENTRICITY = 0.0818191908426;
export const PI_OVER_180 = Math.PI / 180;
export const PI_UNDER_180 = 180 / Math.PI;
